"use strict";
/**
 * Routes App
 * Component: AppRoutes.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.1
 * Data: 05/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var Routes_1 = require("../router/routes/Routes");

var react_1 = require("react");

function AppRoutes(props) {
  react_1.useEffect(function () {
    setRoutesFromChildren();
  }, [props.children]);

  var setRoutesFromChildren = function setRoutesFromChildren() {
    if (props.appState) {
      var children = [];

      if (props.children) {
        if (!(props.children instanceof Array)) {
          children = [props.children];
        } else {
          children = props.children;
        }
      }

      var routesChildren = children.map(function (appRoute) {
        return __assign({
          isPrivate: appRoute.props.isPrivate || !!appRoute.props.permisMinim,
          permisMinim: appRoute.props.permisMinim || -1
        }, appRoute.props);
      });
      props.appState.pantState.setPantalles(routesChildren);
    }
  }; // componentWillReceiveProps(nextProps: IAppRoutesProps) {
  //     if (this.props.children !== nextProps.children) {
  //         this.setRoutesFromChildren();
  //     }
  // }


  if (!props.appState || props.appState.sessState.carregantSessio) {
    return null;
  }

  var isLogged = props.appState.sessState.esLoginat || false;
  var permis = props.appState.config.recCod ? props.appState.sessState.permis : 99;
  var routes = props.appState.pantState.pantalles;
  var marginHead = props.marginHead !== undefined ? props.marginHead : props.appState.pantState.marginHead;
  var marginDrawer = props.marginDrawer !== undefined ? props.marginDrawer : props.appState.menuState.marginDrawer;
  var style = {
    marginTop: marginHead,
    marginLeft: marginDrawer
  };
  return React.createElement("div", {
    id: "main-content",
    style: style
  }, React.createElement(Routes_1.default, {
    isLogged: isLogged,
    permis: permis,
    routes: routes
  }));
}

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(AppRoutes));